var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ingPage"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.tt('기존 랩매니저에서 랩매니저 PRO로 데이터 이전 중입니다.')) + " ")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.tt('최대 10분가량 소요되며, 이전 중에는 기존 랩매니저 서비스 사용이 제한됩니다. 데이터 이전이 완료되면, <b>이메일</b>과 <b>모바일 푸시 알림</b>을 통해 전달 드리겠습니다.'))
    }
  }), _c('img', {
    attrs: {
      "src": require("@/assets/images/transfer.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.timeText) + " 초과")]), _c('b', {
    on: {
      "click": _vm.clickHowToMigration
    }
  }, [_vm._v(_vm._s(_vm.tt('데이터는 어떻게 이전되나요?')))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }